module.exports = __webpack_public_path__ + "img/jinghaiqin.38f5576b.jpg";